import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"width":"100%"}
}
const _hoisted_2 = { style: {"float":"left"} }
const _hoisted_3 = { style: {"float":"right","color":"var(--el-text-color-secondary)","font-size":".8rem"} }
const _hoisted_4 = { style: {"float":"left"} }
const _hoisted_5 = { style: {"float":"right","color":"var(--el-text-color-secondary)","font-size":".8rem"} }
const _hoisted_6 = {
  key: 1,
  style: {"width":"100%"}
}
const _hoisted_7 = { style: {"float":"left"} }
const _hoisted_8 = { style: {"float":"right","color":"var(--el-text-color-secondary)","font-size":".8rem"} }
const _hoisted_9 = {
  key: 0,
  style: {"width":"100%"}
}
const _hoisted_10 = { style: {"float":"left"} }
const _hoisted_11 = { style: {"float":"right","color":"var(--el-text-color-secondary)","font-size":".8rem"} }
const _hoisted_12 = {
  key: 1,
  style: {"width":"100%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_order_status_selector_component = _resolveComponent("order-status-selector-component")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_time_picker = _resolveComponent("el-time-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_select_manager_component = _resolveComponent("select-manager-component")!
  const _component_catalog_picker_component = _resolveComponent("catalog-picker-component")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref: "ff",
    rules: _ctx.rules,
    model: _ctx.f
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        label: "Статус заказа",
        "label-position": "top",
        prop: "status"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_order_status_selector_component, {
            status: _ctx.f.status,
            statuses: _ctx.newOrderAllowedStatuses,
            onChange: _ctx.onStatusChanged
          }, null, 8, ["status", "statuses", "onChange"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "Плановая дата начала работ",
        "label-position": "top",
        prop: "scheduledStartDate"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_date_picker, {
            modelValue: _ctx.f.scheduledStartDate,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => ((_ctx.f.scheduledStartDate) = $event)),
              _ctx.emitUpdate
            ],
            type: "date",
            clearable: false,
            format: "DD.MM.YYYY",
            placeholder: "Дата начала работ"
          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
          _createTextVNode("   "),
          _createVNode(_component_el_time_picker, {
            modelValue: _ctx.f.scheduledStartDate,
            "onUpdate:modelValue": [
              _cache[1] || (_cache[1] = ($event: any) => ((_ctx.f.scheduledStartDate) = $event)),
              _ctx.emitUpdate
            ],
            clearable: false,
            format: "HH:mm",
            placeholder: "Время начала работ"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "Организация-исполнитель",
        "label-position": "top",
        prop: "executiveEntity"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: _ctx.f.executiveEntity,
            "onUpdate:modelValue": [
              _cache[2] || (_cache[2] = ($event: any) => ((_ctx.f.executiveEntity) = $event)),
              _ctx.emitUpdate
            ],
            filterable: "",
            "reserve-keyword": "",
            placeholder: "Выберите из списка"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.executives, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.name,
                  value: item
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "Подразделение",
        "label-position": "top",
        prop: "executiveEntityBranch"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: _ctx.f.executiveEntityBranch,
            "onUpdate:modelValue": [
              _cache[3] || (_cache[3] = ($event: any) => ((_ctx.f.executiveEntityBranch) = $event)),
              _ctx.emitUpdate
            ],
            "value-key": "id",
            filterable: "",
            "reserve-keyword": "",
            placeholder: "Выберите из списка",
            disabled: !_ctx.f.executiveEntity?.id
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.f.executiveEntity?.branches, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.name,
                  value: item
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "disabled", "onUpdate:modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "Менеджер",
        "label-position": "top",
        prop: "manager"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_select_manager_component, {
            modelValue: _ctx.f.managerId,
            "onUpdate:modelValue": [
              _cache[4] || (_cache[4] = ($event: any) => ((_ctx.f.managerId) = $event)),
              _ctx.emitUpdate
            ],
            "load-managers": true
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "Заказчик (контрагент)",
        "label-position": "top",
        prop: "customer"
      }, {
        default: _withCtx(() => [
          (!_ctx.f.vehicle?.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_catalog_picker_component, {
                  ref: "c",
                  auth: "",
                  modelValue: _ctx.f.customer,
                  "onUpdate:modelValue": [
                    _cache[5] || (_cache[5] = ($event: any) => ((_ctx.f.customer) = $event)),
                    _ctx.emitUpdate
                  ],
                  placeholder: "Поиск по имени, фамилии, отчеству, компании, телефону или email",
                  "catalog-tab": _ctx.counterpartiesCatalogTab,
                  "search-url": "/api/counterparties/search",
                  onCatalogItemPicked: _ctx.onCustomerPickedFromCatalog
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("span", _hoisted_2, _toDisplayString(`${scope.lastname} ${scope.firstname} ${scope.middlename ?? ''}`), 1),
                    _createElementVNode("span", _hoisted_3, _toDisplayString(scope.phone), 1)
                  ]),
                  label: _withCtx(() => [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(`${_ctx.f.customer!.lastname} ${_ctx.f.customer!.firstname} ${_ctx.f.customer!.middlename ?? ''}`), 1),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.f.customer!.phone), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "catalog-tab", "onUpdate:modelValue", "onCatalogItemPicked"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_el_select, {
                  clearable: "",
                  modelValue: _ctx.f.customerId,
                  "onUpdate:modelValue": [
                    _cache[6] || (_cache[6] = ($event: any) => ((_ctx.f.customerId) = $event)),
                    _ctx.emitUpdate
                  ],
                  onClear: _ctx.onCounterpartySelectClear
                }, {
                  label: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_7, _toDisplayString(`${_ctx.f.customer?.lastname} ${_ctx.f.customer?.firstname} ${_ctx.f.customer?.middlename ?? ''}`), 1),
                      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.f.customer?.phone), 1)
                    ])
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customers, (c) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: c.id,
                        value: c.id,
                        label: `${c.lastname} ${c.firstname} ${c.middlename ?? ''}`
                      }, null, 8, ["value", "label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onUpdate:modelValue", "onClear"])
              ]))
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "Автомобиль",
        "label-position": "top",
        prop: "vehicle"
      }, {
        default: _withCtx(() => [
          (!_ctx.f.customer?.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_catalog_picker_component, {
                  ref: "v",
                  auth: "",
                  modelValue: _ctx.f.vehicle,
                  "onUpdate:modelValue": [
                    _cache[7] || (_cache[7] = ($event: any) => ((_ctx.f.vehicle) = $event)),
                    _ctx.emitUpdate
                  ],
                  placeholder: "Поиск по марке, производителю, VIN или гос. номеру автомобиля",
                  "search-url": "/api/vehicles/search",
                  "catalog-tab": _ctx.vehicleCatalogTab,
                  "allow-creating": true,
                  onCatalogItemPicked: _ctx.onVehiclePickedFromCatalog
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(`${scope.model?.manufacturer?.name}, ${scope.model?.name}`), 1),
                      _createElementVNode("span", _hoisted_11, _toDisplayString(scope.govermentalNumber ? scope.govermentalNumber : scope.vin), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "catalog-tab", "onUpdate:modelValue", "onCatalogItemPicked"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.f.vehicleId,
                  "onUpdate:modelValue": [
                    _cache[8] || (_cache[8] = ($event: any) => ((_ctx.f.vehicleId) = $event)),
                    _ctx.emitUpdate
                  ],
                  placeholder: "Список автомобилей контрагента",
                  onChange: _ctx.onVehicleSelectChange
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customerVehicles, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        value: item.id,
                        label: `${item.model?.manufacturer?.name}, ${item.model?.name} ${item.govermentalNumber ? item.govermentalNumber : item.vin}`
                      }, null, 8, ["value", "label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange", "onUpdate:modelValue"])
              ]))
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "Комментарии заказчика",
        "label-position": "top"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: _ctx.f.customerNotes,
            "onUpdate:modelValue": [
              _cache[9] || (_cache[9] = ($event: any) => ((_ctx.f.customerNotes) = $event)),
              _ctx.emitUpdate
            ],
            autosize: { minRows: 3, maxRows: 6 },
            type: "textarea",
            maxlength: "5000",
            "show-word-limit": "",
            placeholder: "Комментарии заказчика, видны всем"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "Внутренние комментарии",
        "label-position": "top"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: _ctx.f.internalNotes,
            "onUpdate:modelValue": [
              _cache[10] || (_cache[10] = ($event: any) => ((_ctx.f.internalNotes) = $event)),
              _ctx.emitUpdate
            ],
            autosize: { minRows: 3, maxRows: 6 },
            type: "textarea",
            maxlength: "5000",
            "show-word-limit": "",
            placeholder: "Внутренние комментарии, видны только сотрудникам"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["rules", "model"]))
}